import { useState } from 'react'
import { supabase } from '../lib/supabaseClient'

const A = {
  page: { minHeight: '100vh', background: 'radial-gradient(ellipse at 50% 10%, rgba(77,214,255,.08), transparent 60%), #0e1116', color: '#eaf2fb', fontFamily: "'Saira Condensed', 'Rajdhani', sans-serif", display: 'flex', alignItems: 'center', justifyContent: 'center' },
  display: { fontFamily: "'Orbitron', 'Rajdhani', sans-serif", letterSpacing: '0.12em', textTransform: 'uppercase' },
  panel: { background: 'linear-gradient(135deg, #2a2e36, #1a1d22)', border: '1px solid #4a5058', boxShadow: 'inset 0 1px 0 rgba(255,255,255,.06), inset 0 -1px 0 rgba(0,0,0,.4), 0 4px 12px rgba(0,0,0,.4)', padding: '32px 24px', width: '100%', maxWidth: '400px' },
  input: { width: '100%', background: 'rgba(77,214,255,.04)', color: '#eaf2fb', border: '1px solid rgba(77,214,255,.25)', padding: '12px 16px', fontFamily: "'Saira Condensed', sans-serif", fontSize: '15px', outline: 'none' },
  label: { color: '#9aa6b0', fontSize: '11px', letterSpacing: '0.1em', textTransform: 'uppercase', marginBottom: '4px', display: 'block' },
  btnPrimary: { width: '100%', fontFamily: "'Orbitron', sans-serif", fontSize: '14px', fontWeight: 700, letterSpacing: '0.12em', textTransform: 'uppercase', background: 'linear-gradient(135deg, #ff7a18, #d8500a)', color: '#fff5e8', border: 'none', padding: '14px 20px', cursor: 'pointer', boxShadow: '0 0 14px rgba(255,122,24,.5)' },
}

export default function ResetPassword() {
  const [password, setPassword] = useState('')
  const [confirm, setConfirm] = useState('')
  const [loading, setLoading] = useState(false)
  const [message, setMessage] = useState('')
  const [done, setDone] = useState(false)

  const handleReset = async (e) => {
    e.preventDefault()
    if (password !== confirm) { setMessage('Passwords do not match'); return }
    if (password.length < 6) { setMessage('Password must be at least 6 characters'); return }
    setLoading(true)
    const { error } = await supabase.auth.updateUser({ password })
    if (error) { setMessage(error.message) } else { setDone(true) }
    setLoading(false)
  }

  return (
    <div style={A.page}>
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Orbitron:wght@400;500;600;700&family=Saira+Condensed:wght@400;500;600;700&display=swap');`}</style>
      <div style={A.panel}>
        <div style={{ textAlign: 'center', marginBottom: '20px' }}>
          <div style={{ ...A.display, fontSize: '28px', color: '#ff7a18', marginBottom: '4px' }}>◆ ANUBIS</div>
        </div>

        {done ? (
          <div style={{ textAlign: 'center', marginTop: '16px' }}>
            <p style={{ color: '#4dd6ff', fontWeight: 600, marginBottom: '8px' }}>Password updated</p>
            <p style={{ color: '#9aa6b0', fontSize: '13px' }}>Your password has been changed successfully.</p>
            <button onClick={() => window.location.href = '/auth'} style={{ background: 'none', border: 'none', color: '#ff7a18', cursor: 'pointer', marginTop: '20px', fontSize: '13px', fontWeight: 600 }}>Sign in</button>
          </div>
        ) : (
          <>
            <p style={{ color: '#9aa6b0', textAlign: 'center', marginBottom: '24px', fontSize: '13px' }}>Enter your new password</p>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
              <div><label style={A.label}>New Password</label><input type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" maxLength={72} required style={A.input} /></div>
              <div><label style={A.label}>Confirm Password</label><input type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} placeholder="••••••••" maxLength={72} required style={A.input} /></div>
              {message && <p style={{ color: '#ff4136', fontSize: '13px', textAlign: 'center' }}>{message}</p>}
              <button onClick={handleReset} disabled={loading} style={{ ...A.btnPrimary, opacity: loading ? 0.5 : 1 }}>{loading ? 'UPDATING...' : 'UPDATE PASSWORD'}</button>
            </div>
          </>
        )}
      </div>
    </div>
  )
}
